import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Badge } from '@/components/ui/badge';

type BadgeFlavour = 'successful' | 'warning' | 'destructive' | 'neutral';

interface StatusConfig {
  label: string;
  tooltip: string;
  flavour: BadgeFlavour;
}

const QUALITY_RATING_CONFIG: Record<string, StatusConfig> = {
  GREEN: {
    label: 'integrations.whatsapp.quality_rating.green.label',
    tooltip: 'integrations.whatsapp.quality_rating.green.tooltip',
    flavour: 'successful',
  },
  YELLOW: {
    label: 'integrations.whatsapp.quality_rating.yellow.label',
    tooltip: 'integrations.whatsapp.quality_rating.yellow.tooltip',
    flavour: 'warning',
  },
  RED: {
    label: 'integrations.whatsapp.quality_rating.red.label',
    tooltip: 'integrations.whatsapp.quality_rating.red.tooltip',
    flavour: 'destructive',
  },
  UNKNOWN: {
    label: 'integrations.whatsapp.quality_rating.unknown.label',
    tooltip: 'integrations.whatsapp.quality_rating.unknown.tooltip',
    flavour: 'neutral',
  },
  biz_app: {
    label: 'integrations.whatsapp.connection_mode.biz_app.label',
    tooltip: 'integrations.whatsapp.connection_mode.biz_app.tooltip',
    flavour: 'successful',
  },
  api_only: {
    label: 'integrations.whatsapp.connection_mode.api_only.label',
    tooltip: 'integrations.whatsapp.connection_mode.api_only.tooltip',
    flavour: 'successful',
  },
};

interface WhatsappStatusBadgeProps {
  value: string | undefined;
}

export const WhatsappStatusBadge = ({ value }: WhatsappStatusBadgeProps) => {
  const { t } = useTranslation();

  const statusConfig = value
    ? (QUALITY_RATING_CONFIG[value] ?? QUALITY_RATING_CONFIG.UNKNOWN)
    : QUALITY_RATING_CONFIG.UNKNOWN;

  return (
    <InfoTooltip content={t(statusConfig.tooltip)}>
      <Badge type="secondary" flavour={statusConfig.flavour}>
        {t(statusConfig.label)}
      </Badge>
    </InfoTooltip>
  );
};
